<template>
    <div class="news" :style="bcStyle">
        <div class="head">
            <span v-html="$getConfigText(block.inner.title)"></span>
        </div>
        <div class="inner">
            <swiper :options="swiperOption" ref="swiper">
                <swiper-slide 
                    v-for="(child, index) in childList" :key="index">
                    <div class="box">
                        <div class="box-title" 
                            v-if="block.inner.layout === 1 && child.titleForm.status" 
                            :style="_titleStyle(child.titleForm)">{{ $getConfigText(child.titleForm.title) }}
                        </div>
                        <div class="box-inner">
                            <img-swiper 
                                v-if="child.imgForm.status && child.imgForm.imgList.length" 
                                :key="index" 
                                :list="child.imgForm.imgList"
                                @select="onSelectImg">
                            </img-swiper>
                            <div class="box-inner-title" 
                                v-if="block.inner.layout === 2 && child.titleForm.status" 
                                :style="_titleStyle(child.titleForm)">{{ $getConfigText(child.titleForm.title) }}
                            </div>
                            <div class="news-list">
                                <div class="news-item limit top-text" 
                                    v-if="child.textForm.isTopText" 
                                    :style="_textStyle(child.textForm)"
                                    @click="onClickTopText(child.textForm)">{{ $getConfigText(child.textForm.topText) }}
                                </div>
                                <div class="news-item limit" 
                                    v-for="news in _getNewsTextList(child.textForm)" 
                                    :key="news.newsTypeId"
                                    :style="_textStyle(child.textForm)"
                                    @click="onClickNews(news)">{{ news.title }}
                                </div>
                                <div class="more" 
                                    v-if="child.btnForm.status" 
                                    :style="_btnStyle(child.btnForm)"
                                    @click="onMore(child.btnForm)">{{ $getConfigText(child.btnForm.buttonText) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination news-pagination" slot="pagination" v-show="childList.length > 1"></div>
            </swiper>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.news{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding:0 19px;
    .head{
        margin-top: 1.07rem;
        margin-bottom: 1.07rem;
        font-size: 0.64rem;
        line-height: 1.4;
        font-weight: bold;
    }
    .inner{
        display: flex;
        justify-content: space-evenly;
        width: 375px;
        .swiper-container{
            width: 100%;
            .swiper-slide{
                display: flex;
                justify-content: center;
                padding: 0 0px 30px;
            }
        }
        .box{
            display: flex;
            flex-direction: column;
            width: 336px;
            padding: 16px 0 40px;
            .box-title{
                border-bottom: 1px solid #E2E2E2;
                padding-bottom: 16px;
                margin-bottom: 20px;
            }
            .box-inner{
                display: flex;
                flex-direction: column;
                flex-grow: 1;
                box-shadow: 0px 0px 14px 1px rgba(0,0,0,0.12);
            }
            .box-inner-title{
                padding: 16px 16px 0 16px;
            }
            .news-list{
                position: relative;
                flex-grow: 1;
                padding: 16px 16px 56px 16px;
                .news-item{
                    margin-bottom: 14px;
                    &.limit{
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        word-break: break-all;
                    }
                }
                .more{
                    position: absolute;
                    left: 16px;
                    bottom: 18px;
                }
            }
        }
    }
}
</style>

<script>
import { Style } from '@/config/style.js'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import ImgSwiper from '@/components/common/img-swiper.vue'
export default {
    props: {
        block: Object,
        newsList: Array
    },
    data(){
        return {
            swiperOption: {
                slidesPerView: 1, // 显示的slides数量
                autoplay: false,
                loop: false,
                pagination: {
                    el: '.news-pagination',
                    clickable: true
                }
            }
        }
    },
    computed: {
        bcStyle(){
            return `background:${this.block.backColor};`
        },
        childList(){
            return this.block.inner.children
        }
    },
    components: {
        swiper,
        swiperSlide,
        ImgSwiper
    },
    methods: {
        onSelectImg(obj){
            if(obj.link){
                window.open(obj.link)
            }
        },
        onClickTopText(obj){
            if(obj.topLink){
                window.open(obj.topLink)
            }
        },
        onClickNews(news){
            if(news.contentType === 1){
                window.open(news.url)
            }else{
                window.open(`/#/newsDetail/${news.newsId}`)
            }
        },
        onMore(obj){
            if(obj.buttonJumpUrl){
                window.open(obj.buttonJumpUrl)
            }
        },
        _getNewsTextList(obj){
            if(!this.newsList) return []
            let arr = this.newsList.filter(news => news.type === obj.newsTypeId).slice(0, 10)
            if(obj.isTopText && arr.length === 10) arr.pop()
            return arr
        },
        _titleStyle(obj) {
            return Style.blockTitleStyle(obj)
        },
        _textStyle(obj) {
            return Style.blockTextStyle(obj)
        },
        _btnStyle(obj) {
            return Style.blockBtnStyle(obj)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/templates/m-blocks/news.vue